/**
 * 生成编号
 * @date: 2020/8/23
 */
function createNumber (local) {
  const date = new Date()
  const str = local + [[date.getFullYear(), date.getMonth() + 1, date.getDate()],
    [date.getHours(), date.getMinutes(), date.getSeconds()]
  ].join('').replace(/(?=\b\d\b)/g, '0')
  return str.replace(/,/g, '')
}
export {
  createNumber
}
